import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Table,
} from "antd";
import type { FormInstance } from "antd/es/form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setSelectedMedicinesExport } from "redux/reducer/pharmacyStore";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { convertIosStringToDate2, formatDateToString } from "helper/common";
const { INPUT, CURRENCY, NUMBER } = FIELD_TYPE;
const EditableContext = React.createContext<FormInstance<any> | null>(null);
interface EditableRowProps {
  index: number;
}
interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: string;
  record: any;
  type?: any;
  handleSave: (record: any) => void;
}
const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  type,
  handleSave,
  ...restProps
}) => {
  const inputRef = useRef<any>(null);
  const form = useContext(EditableContext)!;

  const save = async () => {
    try {
      const newRecord = {
        ...record,
        thoiGian: formatDateToString(
          form.getFieldValue("thoiGian"),
          FORMAT_TIME.timeDetail
        ),
      };
      handleSave(newRecord);
    } catch (errInfo) {}
  };

  let childNode = children;
  if (dataIndex == "thoiGian") {
    if (record?.tenChiDinh) {
      childNode = (
        <div
          className="editable-cell-value-wrap"
          style={{
            minHeight: 22,
          }}
        >
          {convertIosStringToDate2(record?.thoiGian)?.format(
            FORMAT_TIME.dateTime
          )}
        </div>
      );
    } else {
      childNode = (
        <Form.Item
          style={{ margin: 0 }}
          name={dataIndex}
          initialValue={
            record ? convertIosStringToDate2(record[dataIndex]) : null
          }
        >
          <DatePicker
            ref={inputRef}
            onChange={save}
            placeholder={"Nhập"}
            format={FORMAT_TIME.dateTime}
            showTime={true}
            // addonAfter="VNĐ"

            {...restProps}
            style={{ width: "100%", padding: 4 }}
          />
        </Form.Item>
      );
    }
  } else {
    childNode = (
      <div
        className="editable-cell-value-wrap"
        style={{
          minHeight: 22,
        }}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

const components = {
  body: {
    row: EditableRow,
    cell: EditableCell,
  },
};

export { EditableCell, EditableRow, components };
